import React, { useEffect, useState } from 'react';

import { FlexBox } from '@eltoro-ui/components';

import './GeneratedCampaign.scss';
import CustomIcons from 'assets/icons';

const LoadingSimulator = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const steps = [
    'Handpicking Your Target Audiences',
    'Crafting Personalized Banner Ads',
    'Building Your One-Click Campaign',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep(prevStep => (prevStep + 1) % steps.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [steps.length]);
  return (
    <FlexBox UNSAFE_className="simulator-container" alignItems="center" justifyContent="center">
      <FlexBox
        UNSAFE_className="loader-content"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <CustomIcons name="magic_hat" fontSize={88} />
        <h3 className="heading">Putting the final touches on your launch-ready campaign...</h3>
        <ul className="loading-steps">
          {steps.map((step, index) => (
            <li
              key={step}
              className={`step ${index === currentStep ? 'loading-step' : 'not-current-step'}`}
            >
              {step}
            </li>
          ))}
        </ul>
      </FlexBox>
    </FlexBox>
  );
};

export default LoadingSimulator;
